import { Action, AnyAction, Reducer, Store } from "redux";

import { bridge } from "@multiweb/reactCore/bridge";
import { getRootReducer } from "./reducer";
import { getRootSaga } from "./saga";
import { createStore, StoreInfo } from "./store";
import { IAppState } from "./types";

const { errorHandler, setStore } = bridge;

export class StoreManager {
    private static _storeInfo: StoreInfo;

    /**
     * Připraví store k použití.
     * @param isDevMode Příznak, zda je aplikace ve vývojovém módu
     */
    public static initializeStore(isDevMode: boolean): void {
        StoreManager.getStore(isDevMode);
    }

    /**
     * Vrací Redux store. Metodu je možné použít pouze po registraci všech custom položek do DIContainer.
     * @param isDevMode Příznak, zda je aplikace ve vývojovém módu
     */
    public static getStore(isDevMode: boolean): Store<any, AnyAction> {
        if (!StoreManager._storeInfo) {
            StoreManager._storeInfo = createStore(isDevMode, this._createCatchingReducer(getRootReducer()), getRootSaga());
            const { store, rootSagaPromise, runSaga } = StoreManager._storeInfo;
            rootSagaPromise.catch(this.handleError);
            setStore(store, runSaga);
        }

        return StoreManager._storeInfo.store;
    }

    private static _createCatchingReducer(rootReducer: Reducer<IAppState>): Reducer {
        return (state: IAppState, action: Action) => {
            try {
                return rootReducer(state, action);
            } catch (error) {
                this.handleError(error);
                return state;
            }
        };
    }

    /**
     * Metoda pro zpracování chyb zachycených v ságách, reducerech a komponentách.
     * @param error Chyba pro zpracování.
     */
    public static handleError(error: unknown): void {
        errorHandler(error);
    }
}
